export default "__VITE_ASSET__Bp$PMcVH__"